var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66699 9.33203L13.5536 16.9526C14.4351 17.5697 14.8759 17.8783 15.3553 17.9978C15.7789 18.1033 16.2218 18.1033 16.6453 17.9978C17.1248 17.8783 17.5655 17.5697 18.4471 16.9526L29.3337 9.33203M9.06699 26.6654H22.9337C25.1739 26.6654 26.294 26.6654 27.1496 26.2294C27.9023 25.8459 28.5142 25.234 28.8977 24.4813C29.3337 23.6257 29.3337 22.5056 29.3337 20.2654V11.732C29.3337 9.49182 29.3337 8.37172 28.8977 7.51607C28.5142 6.76342 27.9023 6.1515 27.1496 5.76801C26.294 5.33203 25.1739 5.33203 22.9337 5.33203H9.06699C6.82678 5.33203 5.70668 5.33203 4.85103 5.76801C4.09838 6.1515 3.48646 6.76342 3.10297 7.51607C2.66699 8.37172 2.66699 9.49182 2.66699 11.732V20.2654C2.66699 22.5056 2.66699 23.6257 3.10297 24.4813C3.48646 25.234 4.09838 25.8459 4.85103 26.2294C5.70668 26.6654 6.82678 26.6654 9.06699 26.6654Z",
    stroke: "#141414",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail01);
export default __webpack_public_path__ + "static/media/mail-01.8b51997d72dde4474d2e2bcd29914e8b.svg";
export { ForwardRef as ReactComponent };